// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Manrope:wght@600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-container,
.landing-container * {
    box-sizing: border-box;
}

.landing-container {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    color: #fff;
    text-align: left;
    font-family: 'DM Sans', sans-serif;
    background:
        linear-gradient(rgba(255,255,255,.025) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255,255,255,.025) 1px, transparent 1px),
        radial-gradient(circle at 78% 38%, rgba(75,112,145,.27), transparent 28rem),
        linear-gradient(145deg, #1b3045 0%, #122538 52%, #0d1c2b 100%);
    background-size: 54px 54px, 54px 54px, auto, auto;
}

.landing-glow {
    position: absolute;
    border-radius: 999px;
    pointer-events: none;
    filter: blur(2px);
}

.landing-glow-one {
    width: 370px;
    height: 370px;
    top: -220px;
    left: 35%;
    background: rgba(239,111,83,.28);
}

.landing-glow-two {
    width: 260px;
    height: 260px;
    right: -130px;
    bottom: 5%;
    border: 55px solid rgba(239,111,83,.08);
}

.landing-header {
    position: relative;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: min(1240px, calc(100% - 3rem));
    height: auto;
    margin: 0 auto;
    padding: 1.65rem 0;
    background: transparent;
    box-shadow: none;
}

.landing-brand {
    display: inline-flex;
    padding: .6rem .9rem;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 12px 30px rgba(0,0,0,.2);
}

.logo-landing {
    display: block;
    width: 145px;
    height: auto;
}

.landing-nav-link {
    display: inline-flex;
    align-items: center;
    gap: .6rem;
    padding: .72rem 1.05rem;
    border: 1px solid rgba(255,255,255,.18);
    border-radius: 999px;
    color: #fff;
    font-size: .86rem;
    font-weight: 700;
    text-decoration: none;
    background: rgba(255,255,255,.06);
    backdrop-filter: blur(10px);
    transition: border-color .2s ease, background .2s ease;
}

.landing-nav-link:hover {
    border-color: rgba(255,255,255,.4);
    background: rgba(255,255,255,.12);
}

.landing-content {
    position: relative;
    z-index: 2;
    display: block;
    min-height: 0;
    padding: 0;
    color: #fff;
    text-align: left;
    overflow: visible;
}

.landing-hero {
    display: grid;
    grid-template-columns: .92fr 1.08fr;
    align-items: center;
    gap: clamp(3rem, 7vw, 7rem);
    width: min(1240px, calc(100% - 3rem));
    min-height: calc(100vh - 190px);
    margin: 0 auto;
    padding: 3rem 0 5rem;
}

.landing-copy {
    position: relative;
    z-index: 3;
}

.landing-kicker {
    display: inline-flex;
    align-items: center;
    gap: .65rem;
    margin-bottom: 1.5rem;
    color: #ffb5a4;
    font-size: .76rem;
    font-weight: 800;
    letter-spacing: .15em;
    text-transform: uppercase;
}

.landing-kicker i {
    font-size: .48rem;
    filter: drop-shadow(0 0 7px #ef6f53);
}

.landing-heading {
    width: auto;
    margin: 0;
    color: #fff;
    font: 800 clamp(3.2rem, 6.2vw, 6.6rem)/.98 'Manrope', sans-serif;
    letter-spacing: -.065em;
    text-shadow: none;
}

.landing-heading span {
    display: block;
    color: #ef6f53;
}

.landing-lede {
    max-width: 600px;
    margin: 1.6rem 0 0;
    color: rgba(255,255,255,.67);
    font-size: clamp(1rem, 1.6vw, 1.16rem);
    line-height: 1.8;
}

.landing-actions {
    display: flex;
    align-items: center;
    gap: 1.4rem;
    margin-top: 2.1rem;
}

.continue-link {
    display: inline-flex;
    align-items: center;
    gap: .8rem;
    margin: 0;
    padding: .95rem 1.35rem;
    border-radius: 13px;
    color: #fff;
    font-size: .92rem;
    font-weight: 700;
    text-decoration: none;
    background: linear-gradient(135deg, #f37b61, #e65d41);
    box-shadow: 0 15px 34px rgba(239,111,83,.28);
    transition: transform .2s ease, box-shadow .2s ease;
}

.continue-link:hover {
    color: #fff;
    background: linear-gradient(135deg, #fb876e, #ee6549);
    transform: translateY(-2px);
    box-shadow: 0 19px 40px rgba(239,111,83,.38);
}

.landing-safe-note {
    display: inline-flex;
    align-items: center;
    gap: .45rem;
    color: rgba(255,255,255,.5);
    font-size: .78rem;
}

.landing-visual {
    position: relative;
    min-width: 0;
    padding: 3rem 1.5rem;
}

.landing-dashboard {
    position: relative;
    z-index: 2;
    padding: 1.25rem;
    border: 1px solid rgba(255,255,255,.16);
    border-radius: 25px;
    color: #20354b;
    background: rgba(248,251,253,.96);
    box-shadow: 0 40px 80px rgba(0,0,0,.34);
    transform: perspective(1200px) rotateY(-5deg) rotateX(2deg);
}

.preview-topbar,
.preview-chart-head,
.preview-activity {
    display: flex;
    align-items: center;
}

.preview-topbar {
    gap: .8rem;
    padding: .2rem .2rem 1rem;
}

.preview-mark,
.preview-avatar,
.preview-pulse {
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    border-radius: 11px;
}

.preview-mark {
    width: 2.4rem;
    height: 2.4rem;
    color: #fff;
    font: 800 1rem 'Manrope', sans-serif;
    background: #ef6f53;
}

.preview-topbar div {
    display: flex;
    flex-direction: column;
}

.preview-topbar small,
.preview-stats small,
.preview-chart small,
.preview-activity small {
    color: #8492a2;
    font-size: .67rem;
}

.preview-topbar strong {
    margin-top: .15rem;
    font-size: .85rem;
}

.preview-avatar {
    width: 2.25rem;
    height: 2.25rem;
    margin-left: auto;
    color: #6b7b8c;
    background: #e7edf2;
}

.preview-stats {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: .8rem;
}

.preview-stats > div {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: 1px solid #e4eaf0;
    border-radius: 15px;
    background: #fff;
}

.preview-stats strong {
    margin-top: .35rem;
    font: 800 1.7rem 'Manrope', sans-serif;
}

.preview-stats em {
    position: absolute;
    right: .8rem;
    bottom: 1rem;
    color: #2c956c;
    font-size: .61rem;
    font-style: normal;
    font-weight: 700;
}

.preview-chart {
    margin-top: .8rem;
    padding: 1rem;
    border: 1px solid #e4eaf0;
    border-radius: 15px;
    background: #fff;
}

.preview-chart-head {
    justify-content: space-between;
}

.preview-chart-head div {
    display: flex;
    flex-direction: column;
}

.preview-chart-head strong {
    margin-top: .2rem;
    font-size: .8rem;
}

.preview-chart-head > span {
    padding: .3rem .55rem;
    border-radius: 999px;
    color: #277354;
    font-size: .62rem;
    font-weight: 700;
    background: #e5f7ee;
}

.preview-bars {
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    gap: .6rem;
    height: 130px;
    padding: 1.2rem .5rem 0;
    border-bottom: 1px solid #e6ebef;
}

.preview-bars i {
    display: block;
    width: 9%;
    min-height: 15px;
    border-radius: 7px 7px 2px 2px;
    background: linear-gradient(180deg, #ef6f53, #f4a08e);
}

.preview-activity {
    gap: .7rem;
    margin-top: .8rem;
    padding: .8rem;
    border-radius: 13px;
    background: #edf4f8;
}

.preview-pulse {
    width: 2rem;
    height: 2rem;
    color: #fff;
    font-size: .68rem;
    background: #2f9b70;
    box-shadow: 0 0 0 5px rgba(47,155,112,.1);
}

.preview-activity div {
    display: flex;
    flex-direction: column;
}

.preview-activity strong {
    font-size: .73rem;
}

.landing-float-card {
    position: absolute;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: .7rem;
    padding: .8rem 1rem;
    border: 1px solid rgba(255,255,255,.14);
    border-radius: 14px;
    background: rgba(26,48,69,.88);
    box-shadow: 0 16px 35px rgba(0,0,0,.3);
    backdrop-filter: blur(13px);
}

.landing-float-card > span {
    display: grid;
    place-items: center;
    width: 2rem;
    height: 2rem;
    border-radius: 9px;
    color: #ff9b84;
    background: rgba(239,111,83,.12);
}

.landing-float-card div {
    display: flex;
    flex-direction: column;
}

.landing-float-card strong {
    font-size: .72rem;
}

.landing-float-card small {
    margin-top: .12rem;
    color: rgba(255,255,255,.5);
    font-size: .59rem;
}

.landing-float-top {
    top: 0;
    right: -1rem;
}

.landing-float-bottom {
    bottom: 1rem;
    left: -1.5rem;
}

.landing-proof {
    display: grid;
    grid-template-columns: 1.25fr repeat(3, 1fr);
    gap: 1rem;
    align-items: center;
    width: min(1240px, calc(100% - 3rem));
    margin: 0 auto;
    padding: 1.5rem 0 2rem;
    border-top: 1px solid rgba(255,255,255,.09);
}

.landing-proof > span {
    color: rgba(255,255,255,.4);
    font-size: .7rem;
    font-weight: 700;
    letter-spacing: .12em;
    text-transform: uppercase;
}

.landing-proof div {
    display: flex;
    flex-direction: column;
}

.landing-proof strong {
    font-size: .82rem;
}

.landing-proof small {
    margin-top: .2rem;
    color: rgba(255,255,255,.4);
    font-size: .68rem;
}

@media (max-width: 960px) {
    .landing-hero {
        grid-template-columns: 1fr;
        gap: 2rem;
        padding-top: 4rem;
    }

    .landing-copy {
        max-width: 720px;
    }

    .landing-visual {
        width: min(650px, 100%);
        margin: 0 auto;
    }

    .landing-proof {
        grid-template-columns: repeat(3, 1fr);
    }

    .landing-proof > span {
        grid-column: 1 / -1;
    }
}

@media (max-width: 620px) {
    .landing-header,
    .landing-hero,
    .landing-proof {
        width: min(100% - 2rem, 1240px);
    }

    .landing-header {
        padding: 1.15rem 0;
    }

    .logo-landing {
        width: 118px;
    }

    .landing-nav-link {
        padding: .62rem .85rem;
    }

    .landing-hero {
        padding: 3rem 0;
    }

    .landing-heading {
        font-size: clamp(3rem, 15vw, 4.4rem);
    }

    .landing-actions {
        align-items: flex-start;
        flex-direction: column;
    }

    .landing-visual {
        padding: 2rem 0;
    }

    .landing-dashboard {
        transform: none;
    }

    .landing-float-card {
        display: none;
    }

    .landing-proof {
        grid-template-columns: 1fr;
    }

    .landing-proof > span {
        grid-column: auto;
    }
}

@media (prefers-reduced-motion: reduce) {
    .continue-link {
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Landing/Landing.css"],"names":[],"mappings":"AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC;;;;sEAIkE;IAClE,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qCAAqC;IACrC,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,uBAAuB;IACvB,uCAAuC;IACvC,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,iCAAiC;IACjC,2BAA2B;IAC3B,sDAAsD;AAC1D;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,aAAa;IACb,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,qCAAqC;IACrC,+BAA+B;IAC/B,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,SAAS;IACT,WAAW;IACX,gEAAgE;IAChE,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,qDAAqD;IACrD,4CAA4C;IAC5C,mDAAmD;AACvD;;AAEA;IACI,WAAW;IACX,qDAAqD;IACrD,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;IACnB,cAAc;IACd,iCAAiC;IACjC,uCAAuC;IACvC,2DAA2D;AAC/D;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,WAAW;IACX,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;;IAII,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;IAC7B,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,8BAA8B;IAC9B,qDAAqD;AACzD;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,SAAS;IACT,mBAAmB;IACnB,qCAAqC;IACrC,cAAc;IACd,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;;;QAGI,+BAA+B;IACnC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Manrope:wght@600;700;800&display=swap');\n\n.landing-container,\n.landing-container * {\n    box-sizing: border-box;\n}\n\n.landing-container {\n    position: relative;\n    min-height: 100vh;\n    overflow: hidden;\n    color: #fff;\n    text-align: left;\n    font-family: 'DM Sans', sans-serif;\n    background:\n        linear-gradient(rgba(255,255,255,.025) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(255,255,255,.025) 1px, transparent 1px),\n        radial-gradient(circle at 78% 38%, rgba(75,112,145,.27), transparent 28rem),\n        linear-gradient(145deg, #1b3045 0%, #122538 52%, #0d1c2b 100%);\n    background-size: 54px 54px, 54px 54px, auto, auto;\n}\n\n.landing-glow {\n    position: absolute;\n    border-radius: 999px;\n    pointer-events: none;\n    filter: blur(2px);\n}\n\n.landing-glow-one {\n    width: 370px;\n    height: 370px;\n    top: -220px;\n    left: 35%;\n    background: rgba(239,111,83,.28);\n}\n\n.landing-glow-two {\n    width: 260px;\n    height: 260px;\n    right: -130px;\n    bottom: 5%;\n    border: 55px solid rgba(239,111,83,.08);\n}\n\n.landing-header {\n    position: relative;\n    z-index: 5;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: min(1240px, calc(100% - 3rem));\n    height: auto;\n    margin: 0 auto;\n    padding: 1.65rem 0;\n    background: transparent;\n    box-shadow: none;\n}\n\n.landing-brand {\n    display: inline-flex;\n    padding: .6rem .9rem;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 12px 30px rgba(0,0,0,.2);\n}\n\n.logo-landing {\n    display: block;\n    width: 145px;\n    height: auto;\n}\n\n.landing-nav-link {\n    display: inline-flex;\n    align-items: center;\n    gap: .6rem;\n    padding: .72rem 1.05rem;\n    border: 1px solid rgba(255,255,255,.18);\n    border-radius: 999px;\n    color: #fff;\n    font-size: .86rem;\n    font-weight: 700;\n    text-decoration: none;\n    background: rgba(255,255,255,.06);\n    backdrop-filter: blur(10px);\n    transition: border-color .2s ease, background .2s ease;\n}\n\n.landing-nav-link:hover {\n    border-color: rgba(255,255,255,.4);\n    background: rgba(255,255,255,.12);\n}\n\n.landing-content {\n    position: relative;\n    z-index: 2;\n    display: block;\n    min-height: 0;\n    padding: 0;\n    color: #fff;\n    text-align: left;\n    overflow: visible;\n}\n\n.landing-hero {\n    display: grid;\n    grid-template-columns: .92fr 1.08fr;\n    align-items: center;\n    gap: clamp(3rem, 7vw, 7rem);\n    width: min(1240px, calc(100% - 3rem));\n    min-height: calc(100vh - 190px);\n    margin: 0 auto;\n    padding: 3rem 0 5rem;\n}\n\n.landing-copy {\n    position: relative;\n    z-index: 3;\n}\n\n.landing-kicker {\n    display: inline-flex;\n    align-items: center;\n    gap: .65rem;\n    margin-bottom: 1.5rem;\n    color: #ffb5a4;\n    font-size: .76rem;\n    font-weight: 800;\n    letter-spacing: .15em;\n    text-transform: uppercase;\n}\n\n.landing-kicker i {\n    font-size: .48rem;\n    filter: drop-shadow(0 0 7px #ef6f53);\n}\n\n.landing-heading {\n    width: auto;\n    margin: 0;\n    color: #fff;\n    font: 800 clamp(3.2rem, 6.2vw, 6.6rem)/.98 'Manrope', sans-serif;\n    letter-spacing: -.065em;\n    text-shadow: none;\n}\n\n.landing-heading span {\n    display: block;\n    color: #ef6f53;\n}\n\n.landing-lede {\n    max-width: 600px;\n    margin: 1.6rem 0 0;\n    color: rgba(255,255,255,.67);\n    font-size: clamp(1rem, 1.6vw, 1.16rem);\n    line-height: 1.8;\n}\n\n.landing-actions {\n    display: flex;\n    align-items: center;\n    gap: 1.4rem;\n    margin-top: 2.1rem;\n}\n\n.continue-link {\n    display: inline-flex;\n    align-items: center;\n    gap: .8rem;\n    margin: 0;\n    padding: .95rem 1.35rem;\n    border-radius: 13px;\n    color: #fff;\n    font-size: .92rem;\n    font-weight: 700;\n    text-decoration: none;\n    background: linear-gradient(135deg, #f37b61, #e65d41);\n    box-shadow: 0 15px 34px rgba(239,111,83,.28);\n    transition: transform .2s ease, box-shadow .2s ease;\n}\n\n.continue-link:hover {\n    color: #fff;\n    background: linear-gradient(135deg, #fb876e, #ee6549);\n    transform: translateY(-2px);\n    box-shadow: 0 19px 40px rgba(239,111,83,.38);\n}\n\n.landing-safe-note {\n    display: inline-flex;\n    align-items: center;\n    gap: .45rem;\n    color: rgba(255,255,255,.5);\n    font-size: .78rem;\n}\n\n.landing-visual {\n    position: relative;\n    min-width: 0;\n    padding: 3rem 1.5rem;\n}\n\n.landing-dashboard {\n    position: relative;\n    z-index: 2;\n    padding: 1.25rem;\n    border: 1px solid rgba(255,255,255,.16);\n    border-radius: 25px;\n    color: #20354b;\n    background: rgba(248,251,253,.96);\n    box-shadow: 0 40px 80px rgba(0,0,0,.34);\n    transform: perspective(1200px) rotateY(-5deg) rotateX(2deg);\n}\n\n.preview-topbar,\n.preview-chart-head,\n.preview-activity {\n    display: flex;\n    align-items: center;\n}\n\n.preview-topbar {\n    gap: .8rem;\n    padding: .2rem .2rem 1rem;\n}\n\n.preview-mark,\n.preview-avatar,\n.preview-pulse {\n    display: grid;\n    place-items: center;\n    flex: 0 0 auto;\n    border-radius: 11px;\n}\n\n.preview-mark {\n    width: 2.4rem;\n    height: 2.4rem;\n    color: #fff;\n    font: 800 1rem 'Manrope', sans-serif;\n    background: #ef6f53;\n}\n\n.preview-topbar div {\n    display: flex;\n    flex-direction: column;\n}\n\n.preview-topbar small,\n.preview-stats small,\n.preview-chart small,\n.preview-activity small {\n    color: #8492a2;\n    font-size: .67rem;\n}\n\n.preview-topbar strong {\n    margin-top: .15rem;\n    font-size: .85rem;\n}\n\n.preview-avatar {\n    width: 2.25rem;\n    height: 2.25rem;\n    margin-left: auto;\n    color: #6b7b8c;\n    background: #e7edf2;\n}\n\n.preview-stats {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: .8rem;\n}\n\n.preview-stats > div {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    border: 1px solid #e4eaf0;\n    border-radius: 15px;\n    background: #fff;\n}\n\n.preview-stats strong {\n    margin-top: .35rem;\n    font: 800 1.7rem 'Manrope', sans-serif;\n}\n\n.preview-stats em {\n    position: absolute;\n    right: .8rem;\n    bottom: 1rem;\n    color: #2c956c;\n    font-size: .61rem;\n    font-style: normal;\n    font-weight: 700;\n}\n\n.preview-chart {\n    margin-top: .8rem;\n    padding: 1rem;\n    border: 1px solid #e4eaf0;\n    border-radius: 15px;\n    background: #fff;\n}\n\n.preview-chart-head {\n    justify-content: space-between;\n}\n\n.preview-chart-head div {\n    display: flex;\n    flex-direction: column;\n}\n\n.preview-chart-head strong {\n    margin-top: .2rem;\n    font-size: .8rem;\n}\n\n.preview-chart-head > span {\n    padding: .3rem .55rem;\n    border-radius: 999px;\n    color: #277354;\n    font-size: .62rem;\n    font-weight: 700;\n    background: #e5f7ee;\n}\n\n.preview-bars {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-around;\n    gap: .6rem;\n    height: 130px;\n    padding: 1.2rem .5rem 0;\n    border-bottom: 1px solid #e6ebef;\n}\n\n.preview-bars i {\n    display: block;\n    width: 9%;\n    min-height: 15px;\n    border-radius: 7px 7px 2px 2px;\n    background: linear-gradient(180deg, #ef6f53, #f4a08e);\n}\n\n.preview-activity {\n    gap: .7rem;\n    margin-top: .8rem;\n    padding: .8rem;\n    border-radius: 13px;\n    background: #edf4f8;\n}\n\n.preview-pulse {\n    width: 2rem;\n    height: 2rem;\n    color: #fff;\n    font-size: .68rem;\n    background: #2f9b70;\n    box-shadow: 0 0 0 5px rgba(47,155,112,.1);\n}\n\n.preview-activity div {\n    display: flex;\n    flex-direction: column;\n}\n\n.preview-activity strong {\n    font-size: .73rem;\n}\n\n.landing-float-card {\n    position: absolute;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    gap: .7rem;\n    padding: .8rem 1rem;\n    border: 1px solid rgba(255,255,255,.14);\n    border-radius: 14px;\n    background: rgba(26,48,69,.88);\n    box-shadow: 0 16px 35px rgba(0,0,0,.3);\n    backdrop-filter: blur(13px);\n}\n\n.landing-float-card > span {\n    display: grid;\n    place-items: center;\n    width: 2rem;\n    height: 2rem;\n    border-radius: 9px;\n    color: #ff9b84;\n    background: rgba(239,111,83,.12);\n}\n\n.landing-float-card div {\n    display: flex;\n    flex-direction: column;\n}\n\n.landing-float-card strong {\n    font-size: .72rem;\n}\n\n.landing-float-card small {\n    margin-top: .12rem;\n    color: rgba(255,255,255,.5);\n    font-size: .59rem;\n}\n\n.landing-float-top {\n    top: 0;\n    right: -1rem;\n}\n\n.landing-float-bottom {\n    bottom: 1rem;\n    left: -1.5rem;\n}\n\n.landing-proof {\n    display: grid;\n    grid-template-columns: 1.25fr repeat(3, 1fr);\n    gap: 1rem;\n    align-items: center;\n    width: min(1240px, calc(100% - 3rem));\n    margin: 0 auto;\n    padding: 1.5rem 0 2rem;\n    border-top: 1px solid rgba(255,255,255,.09);\n}\n\n.landing-proof > span {\n    color: rgba(255,255,255,.4);\n    font-size: .7rem;\n    font-weight: 700;\n    letter-spacing: .12em;\n    text-transform: uppercase;\n}\n\n.landing-proof div {\n    display: flex;\n    flex-direction: column;\n}\n\n.landing-proof strong {\n    font-size: .82rem;\n}\n\n.landing-proof small {\n    margin-top: .2rem;\n    color: rgba(255,255,255,.4);\n    font-size: .68rem;\n}\n\n@media (max-width: 960px) {\n    .landing-hero {\n        grid-template-columns: 1fr;\n        gap: 2rem;\n        padding-top: 4rem;\n    }\n\n    .landing-copy {\n        max-width: 720px;\n    }\n\n    .landing-visual {\n        width: min(650px, 100%);\n        margin: 0 auto;\n    }\n\n    .landing-proof {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    .landing-proof > span {\n        grid-column: 1 / -1;\n    }\n}\n\n@media (max-width: 620px) {\n    .landing-header,\n    .landing-hero,\n    .landing-proof {\n        width: min(100% - 2rem, 1240px);\n    }\n\n    .landing-header {\n        padding: 1.15rem 0;\n    }\n\n    .logo-landing {\n        width: 118px;\n    }\n\n    .landing-nav-link {\n        padding: .62rem .85rem;\n    }\n\n    .landing-hero {\n        padding: 3rem 0;\n    }\n\n    .landing-heading {\n        font-size: clamp(3rem, 15vw, 4.4rem);\n    }\n\n    .landing-actions {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .landing-visual {\n        padding: 2rem 0;\n    }\n\n    .landing-dashboard {\n        transform: none;\n    }\n\n    .landing-float-card {\n        display: none;\n    }\n\n    .landing-proof {\n        grid-template-columns: 1fr;\n    }\n\n    .landing-proof > span {\n        grid-column: auto;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .continue-link {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
